import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PricingLevelsTypes } from "@/types";

export interface PricingLevelGetState {
  pricingLevel: PricingLevelsTypes.PricingLevel;
}

const defaultPricingLevel: PricingLevelsTypes.PricingLevel= {
  created_at: "",
  id: null,
};

const DEFAULT_PRICING_LEVEL_GET_STATE: PricingLevelGetState = {
  pricingLevel: defaultPricingLevel,
};

export default (state: PricingLevelGetState = DEFAULT_PRICING_LEVEL_GET_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_PRICING_LEVEL_RESULTS) {
    return {
      ...state,
      pricingLevel: action.payload,
    };
  } else if (action.type === ActionTypes.UPDATE_PRICING_LEVEL_RESULTS) {
    return {
      ...state,
      pricingLevel: action.payload,
    };
  } else if (action.type === ActionTypes.CREATE_PRICING_LEVEL_RESULTS) {
    return {
      ...state,
      pricingLevel: action.payload,
    };
  } else {
    return state;
  }
};
